import React from "react";
import "./style.css";

const Logo = () => {
  return (
    <center>
      <div className="logo">
        <a href="#">Musarrat Anjum Chowdhury</a>
      </div>
    </center>
  );
};

export default Logo;
